import { Controller } from "@hotwired/stimulus"

// Auto-refreshes the page when new content is expected
// Uses sessionStorage to track state across page refreshes
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 2000 },
    count: { type: Number, default: 0 }
  }

  connect() {
    const storageKey = `import_${window.location.pathname}`
    const stored = sessionStorage.getItem(storageKey)
    let state = stored ? JSON.parse(stored) : { startTime: Date.now(), lastCount: -1, stableChecks: 0 }

    const currentCount = this.countValue
    const elapsed = Date.now() - state.startTime

    // Check if import is complete (count stable for 2 checks, or timeout after 2 min)
    if (currentCount === state.lastCount && currentCount > 0) {
      state.stableChecks++
    } else {
      state.stableChecks = 0
    }
    state.lastCount = currentCount

    // Save state
    sessionStorage.setItem(storageKey, JSON.stringify(state))

    // Stop conditions: stable for 2 checks OR timeout after 2 minutes
    if ((state.stableChecks >= 2 && currentCount > 0) || elapsed > 120000) {
      this.finishImport(storageKey)
      return
    }

    // Schedule next refresh
    this.refreshTimer = setTimeout(() => {
      window.location.reload()
    }, this.intervalValue)
  }

  disconnect() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer)
    }
  }

  finishImport(storageKey) {
    sessionStorage.removeItem(storageKey)
    // Remove the importing param
    const url = new URL(window.location.href)
    url.searchParams.delete('importing')
    history.replaceState(null, '', url.toString())
    // Remove the banner element
    this.element.remove()
  }
}
